import { InjectionToken } from '@angular/core';

export const BASE_URL = new InjectionToken<string>('BASE_URL');

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}
